import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { SwitchStaffPaymentDetailsTable } from "../../views/pages/gymPortion/reports/switchStaffPaymentDetailsTable";
import { setShowSwitchStaffPaymentDetailsModal } from "../../redux/actions/reports/reportsAction";

export const SwitchStaffPaymentDetailsModal = ({ id, data }) => {
    const { showSwitchStaffPaymentDetails } = useSelector((state) => state.report);
    const dispatch = useDispatch();

    const toggle = () => {
        dispatch(setShowSwitchStaffPaymentDetailsModal({ [id]: false }));
    }
    return (
        <>
            {
                showSwitchStaffPaymentDetails[id] && data?.length &&
                <Modal isOpen={showSwitchStaffPaymentDetails[id]} toggle={toggle} centered={true}
                size="lg"
                className="large-pop adding-popup ">
                    <ModalHeader toggle={toggle}>Session Payment Details</ModalHeader>
                    <ModalBody>
                    <SwitchStaffPaymentDetailsTable data={data}/>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            }
        </>
    );
};
